/** People Landing — campos del bloque "team". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { EditorFieldProps } from '../types';

export function DynamicFields({ draft, set }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <p className="text-sm text-muted-foreground text-pretty">
        {draft.type === 'video'
          ? t('people_landing.editor.dynamic_video_hint', 'Usa el video de bienvenida configurado en el panel de People salvo que pegues otra URL de YouTube (/embed/) o Drive (/preview). Para ingresos es la pieza central; para el resto, un botón "Volver a ver la bienvenida".')
          : draft.type === 'news'
            ? t('people_landing.editor.dynamic_news_hint', 'Contenido automático: ingresos del mes y aniversarios. Se muestra a todos.')
            : t('people_landing.editor.dynamic_onboarding_hint', 'Contenido automático desde la planilla de altas. Solo lo ve quien está en onboarding (primeros 30 días); para el resto se oculta sin dejar hueco.')}
      </p>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.section_title', 'Título de sección (opcional)')}</Label>
        <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
      </div>
      {draft.type === 'video' && (
        <div className="space-y-1.5">
          <Label>{t('people_landing.editor.video_url', 'URL del video (opcional)')}</Label>
          <Input value={draft.url ?? ''} onChange={(e) => set({ url: e.target.value })} placeholder="https://drive.google.com/file/d/…/preview" />
        </div>
      )}
    </>
  );
}
